/* 4Smoke: banner de cookies ligado a API de privacidade da Shopify (Customer Privacy API). */
class CookiesBanner extends HTMLElement {
  constructor() {
    super();
    this.bound = false;
    this.initCookieBanner();
  }

  initCookieBanner() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;
    var canTrack = cp.userCanBeTracked();
    var consent = cp.getTrackingConsent();
    if (Shopify.designMode || (!canTrack && consent === 'no_interaction')) this.showBanner();
  }

  showBanner() {
    if (Shopify.designMode) { this.afterShowBanner(); return; }
    fetch(window.Shopify.routes.root + '?section_id=cookies-banner&view=ajax')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.cookies-banner__inner');
        if (!inner) return;
        this.appendChild(inner);
        this.afterShowBanner();
      }.bind(this))
      .catch(function () {});
  }

  afterShowBanner() {
    requestAnimationFrame(function () { this.classList.add('open'); }.bind(this));
    if (this.bound) return;
    this.bound = true;
    var self = this;
    this.querySelectorAll('.cookies-banner__button--accept').forEach(function (b) {
      b.addEventListener('click', function () { self.save({ analytics: true, marketing: true, preferences: true, sale_of_data: true }); });
    });
    this.querySelectorAll('.cookies-banner__button--decline').forEach(function (b) {
      b.addEventListener('click', function () { self.save({ analytics: false, marketing: false, preferences: false, sale_of_data: false }); });
    });
    var custom = this.querySelector('.cookies-banner__button--customize');
    if (custom) custom.addEventListener('click', function () { self.openPrefs(); });
    var saveBtn = this.querySelector('.cookies-banner__button--save');
    if (saveBtn) saveBtn.addEventListener('click', function () {
      var v = {};
      self.querySelectorAll('[data-ck]').forEach(function (i) { v[i.getAttribute('data-ck')] = i.checked; });
      v.sale_of_data = !!v.marketing;
      self.save(v);
    });
  }

  openPrefs() {
    var prefs = this.querySelector('.s4-ck__prefs');
    var save = this.querySelector('.cookies-banner__button--save');
    var accept = this.querySelector('.cookies-banner__button--accept');
    if (prefs) prefs.hidden = false;
    if (save) save.hidden = false;
    if (accept) accept.hidden = true;
    this.classList.add('is-custom');
  }

  hideBanner() {
    this.classList.remove('open');
  }

  save(values) {
    var self = this;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || Shopify.designMode) { self.hideBanner(); return; }
    try {
      cp.setTrackingConsent(values, function () { self.hideBanner(); });
    } catch (e) {
      try { cp.setTrackingConsent(!!values.analytics, function () { self.hideBanner(); }); } catch (e2) { self.hideBanner(); }
    }
  }
}

window.Shopify.loadFeatures(
  [{ name: 'consent-tracking-api', version: '0.1' }],
  function (error) {
    if (error) return;
    if (!customElements.get('cookies-banner')) customElements.define('cookies-banner', CookiesBanner);
  }
);
